/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as s from "react";
import r from "prop-types";
import { classNames as a } from "@progress/kendo-react-common";
const t = (e) => /* @__PURE__ */ s.createElement(
  "div",
  {
    style: e.style,
    className: a(
      "k-card-body",
      e.className
    )
  },
  e.children
);
t.propTypes = {
  className: r.string
};
export {
  t as CardBody
};
